<template>
  <router-link :to="to" class="report-button">
    <i v-if="icon" class="fa-solid fa-file-lines report-button-icon"></i>
    <span class="report-button-text" :style="{ letterSpacing }">{{ label }}</span>
  </router-link>
</template>

<script setup>
import {computed, defineProps} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyColor = computed(() => companySettings.value?.colorCode || '#15803d')

defineProps({
  to: {
    type: [String, Object],
    required: true
  },
  label: {
    type: String,
    default: 'Bericht'
  },
  icon: {
    type: Boolean,
    default: true
  },
  letterSpacing: {
    type: String,
    default: 'normal'
  }
})
</script>

<style scoped>
.report-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid v-bind(companyColor);
  color: #ffffff;
  background-color: v-bind(companyColor);
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none !important;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.report-button:hover {
  filter: brightness(0.9);
  transform: translateY(-1px);
  color: #ffffff;
}

.report-button-icon {
  font-size: 12px;
  color: #ffffff;
}

.report-button-text {
  white-space: nowrap;
}
</style>
